import paginationFactory from "react-bootstrap-table2-paginator";

export const Pagination = (page:number|string, sizePerPage:number, totalSize:number, showOnlyPages:boolean) => {
  const pageListRenderer = ({ pages, onPageChange }:{
      pages:Array<number|string>
      onPageChange:()=>void
  }) => {
    const pageWithoutIndication = pages.filter((p) => typeof p.page !== 'string')
    return (
      <div>
        {pageWithoutIndication.map((p) => (
          <button className="btn btn-dark" onClick={() => onPageChange(p.page)}>
            {p.page}
          </button>
        ))}
      </div>
    )
  }

    let options = {
        page,
        sizePerPage,
        totalSize,
        withFirstAndLast: true, // hide the going to first and last page button
        alwaysShowAllBtns: true, // always show the next and previous page button
        firstPageText: 'First', // the text of first page button
        prePageText: 'Prev', // the text of previous page button
        nextPageText: 'Next', // the text of next page button
        lastPageText: 'Last', // the text of last page button
        nextPageTitle: 'Go to next', // the title of next page button
        prePageTitle: 'Go to previous', // the title of previous page button
        firstPageTitle: 'Go to first', // the title of first page button
        lastPageTitle: 'Go to last', // the title of last page button
        hideSizePerPage: true, // hide the size per page dropdown
        hidePageListOnlyOnePage: false,
    }
    if (showOnlyPages) {
        options.pageListRenderer = pageListRenderer
    }
    return paginationFactory(options)
}
